/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GroupSettings } from '../models/GroupSettings';
import { GroupTypeEnum } from '../models/GroupTypeEnum';
import { SimpleGroupHorse } from '../models/SimpleGroupHorse';
import { SimpleGroupUser } from '../models/SimpleGroupUser';
import { URI } from '../models/URI';
import { HttpFile } from '../http/http';

export class GroupProfile {
    'uid': string;
    'name'?: string;
    'description'?: string;
    'locationString'?: string;
    'website'?: string;
    'horses': Array<SimpleGroupHorse>;
    'users': Array<SimpleGroupUser>;
    'numberOfHorses': number;
    'settings'?: GroupSettings;
    'groupType': GroupTypeEnum;
    'country'?: string;
    'thumbnail'?: URI;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "uid",
            "baseName": "uid",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "locationString",
            "baseName": "locationString",
            "type": "string",
            "format": ""
        },
        {
            "name": "website",
            "baseName": "website",
            "type": "string",
            "format": ""
        },
        {
            "name": "horses",
            "baseName": "horses",
            "type": "Array<SimpleGroupHorse>",
            "format": ""
        },
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<SimpleGroupUser>",
            "format": ""
        },
        {
            "name": "numberOfHorses",
            "baseName": "numberOfHorses",
            "type": "number",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "GroupSettings",
            "format": ""
        },
        {
            "name": "groupType",
            "baseName": "groupType",
            "type": "GroupTypeEnum",
            "format": ""
        },
        {
            "name": "country",
            "baseName": "country",
            "type": "string",
            "format": ""
        },
        {
            "name": "thumbnail",
            "baseName": "thumbnail",
            "type": "URI",
            "format": "uri"
        }    ];

    static getAttributeTypeMap() {
        return GroupProfile.attributeTypeMap;
    }

    public constructor() {
    }
}



